import React, { Component } from 'react'
import { observable, makeObservable } from 'mobx'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'

import Button from '../../UniformComponents/Button'
import CKeditor5 from '../CKeditor5'
import PanelAccordion from '../PanelAccordion'

import './styles/defaultPage.scss'

@observer
export default class WelcomePage extends Component {
    @observable saveState = ''

    @observable show = true

    constructor(props) {
        super(props)
        makeObservable(this)
    }

    savePage = () => {
        const that = this
        const { store } = this.props
        const { survey } = store

        if (store.survey.closed) {
            return
        }

        const langCode = store.surveyLocale
        console.log('savePage')
        const content = {
            locale: langCode,
            text: survey.content.welcomeContent.get(langCode).text,
        }

        store.http.put(`/api/survey/${survey.id}/welcomeText`, JSON.stringify(content), store.surveyToken)
            .then((response) => {
                const state = response.match(/updated/) ? 'saved' : 'failed'
                if (state === 'saved') {
                    store.addNotification(null, 'Welcome page saved', 'success')
                } else {
                    store.addNotification(null, 'Error saving welcome page', 'error')
                }
                that.saveState = state
            })
            .catch((e) => {
                console.log(e)
                store.addNotification(null, e.message, 'error')
                that.saveState = 'failed'
            })
    }

    handleEditorChange = (value) => {
        const { store } = this.props
        const { survey, surveyLocale } = store

        if (survey.closed) {
            return
        }

        if (!survey.content.welcomeContent.has(surveyLocale)) {
            survey.content.welcomeContent.set(surveyLocale, {
                text: '',
            })
        }

        survey.content.welcomeContent.get(surveyLocale).text = value
        this.saveState = ''
    }

    toggleShow = () => {
        this.show = !this.show
    }

    getContent = () => {
        const { store } = this.props
        const { survey, surveyLocale } = store
        const { defaultLocale } = survey.metadata

        console.log('getcontent', surveyLocale, survey.content.welcomeContent.get(surveyLocale))

        if (survey.content.welcomeContent.has(surveyLocale)) {
            return survey.content.welcomeContent.get(surveyLocale).text
        }

        if (survey.content.welcomeContent.has(defaultLocale)) {
            return survey.content.welcomeContent.get(defaultLocale).text
        }

        return ''
    }

    addFirstPage = () => {
        const welcomePageInx = 0
        const { store, page } = this.props
        const { survey } = store
        if (survey.closed || page.isHidden) return
        survey.addPage(store, welcomePageInx + 1)
    }

    showAddPageBlock = () => {
        const { store } = this.props
        const { survey } = store
        return R.pathOr('', ['metadata', 'taxonomy', 'surveyType'], survey) === 'EM'
    }

    render() {
        const { page_id, store } = this.props
        const { survey } = store
        const key = `${page_id}tinymce`

        return (
            <PanelAccordion
                title={i18n.t('s_alt_welcomepage')}
                show={this.show}
                toggle={this.toggleShow}
                disabled={survey.closed}
                hideOptions
            >
                <div className="page-accordion-content">
                    <CKeditor5
                        activeClass="p10"
                        toolbar="survey"
                        key={key}
                        store={store}
                        config={{
                            mergeFields: store.mergeFields,
                        }}
                        data={this.getContent()}
                        onBlur={this.handleEditorChange}
                    />

                    <br />

                    <div style={{ display: 'flex', justifyContent: 'right', gap: 5 }}>
                        {this.showAddPageBlock() && (
                            <Button
                                label={i18n.t('builder_addPageBlock')}
                                onClick={() => survey.createPageBlock(store)}
                                icon="fal fa-plus"
                                cssClass="regular primary"
                            />
                        )}
                        <Button
                            cssClass="regular primary"
                            label={i18n.t('s_add_surveypage')}
                            icon="fal fa-circle-plus"
                            onClick={this.addFirstPage}
                        />

                        <Button
                            cssClass="regular primary"
                            onClick={this.savePage}
                            label={i18n.t('save_text')}
                        />
                    </div>
                </div>
                <div style={{ clear: 'both' }} />
            </PanelAccordion>
        )
    }
}
